import { jsx as _jsx } from "react/jsx-runtime";
import classnames from "classnames";
import { useDirection } from "@jti/fe-common";
import { SwiperJti, SwiperSlide } from "../../components/SwiperJti";
import { ImageGalleryTopic } from "./ImageGalleryTopic";
import styles from "./ImageGallery.module.scss";
export const ImageGallery = ({ data, mode = "light" }) => {
    const direction = useDirection();
    const rtl = direction === "rtl";
    const imageGalleryClassNames = classnames(styles.imageGallery, {
        [styles.imageGalleryDark]: mode === "dark",
        [styles.imageGalleryRtl]: rtl,
    });
    return (_jsx(SwiperJti, { swiperJtiWrapper: styles.imageGalleryWrapper, swiperJtiClass: imageGalleryClassNames, isShowPaginationButtons: false, speed: 0, autoHeight: true, mode: mode, rtl: rtl, "data-testid": "image-gallery", children: data.map((slide) => (_jsx(SwiperSlide, { children: _jsx(ImageGalleryTopic, { data: slide, mode: mode }) }, `${slide.title}${slide.subtitle}`))) }));
};
//# sourceMappingURL=ImageGallery.js.map